import React, { useEffect, useState, useContext, useRef } from "react";
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { DynamicInput } from "../../../components/DynamicInput";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { StldRow } from "../../../styled-components/StldRow.style";
import { useForm } from 'react-hook-form';
import api from '../../../services/api';
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToggleSwitch } from "../../../components/ToggleSwitch";
import { getClients } from '../../../services/clientes';
import * as moment from 'moment'
import DatePicker from 'react-datepicker';
import InputMask from "react-input-mask";
import Flex from '@react-css/flex';
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import XLSX from 'sheetjs-style';
import { getPeritos } from '../../../services/peritos';
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { Multiselect } from 'multiselect-react-dropdown';
import { getStatus } from '../../../services/status';
import useUser from "../../../utils/useUser";
import { Link } from "react-router-dom";
import { IconRefresh } from "../../../svg";
import { getAreas } from '../../../services/areas';
import Swal from "sweetalert2";

const getLista = async (formValues) => {
    let list = null;
    let params = "";

    if (formValues.Segurado?.length > 0) {
        params += `&Segurado=${formValues.Segurado}`;
    }

    if (formValues.Sigla?.length > 0) {
        params += `&Sigla=${formValues.Sigla}`;
    }

    if (formValues.NumeroTimesheet?.length > 0) {
        params += `&NumeroTimesheet=${formValues.NumeroTimesheet}`;
    }

    if (formValues.idCliente > 0) {
        params += `&IdCliente=${formValues.idCliente}`;
    }

    if (formValues.idPeritos.length > 0) {
        formValues.idPeritos.forEach(idPerito => {
            params += `&IdPeritos=${idPerito}`;
        });
    }

    if (formValues.status.length > 0) {
        formValues.status.forEach(idStatus => {
            if(idStatus != undefined)
            {
                params += `&status=${idStatus}`;
            }
        });
    }

    if (formValues.startDate) {
        params += `&PeriodoInicial=${moment(formValues.startDate).startOf('day').format('YYYY-MM-DD HH:mm')}`;
    }

    if (formValues.endDate) {
        params += `&PeriodoFinal=${moment(formValues.endDate).endOf('day').format('YYYY-MM-DD HH:mm')}`;
    }

    params += `&SomenteProBono=${formValues.somenteProBono}`;

    if (formValues.areas?.length > 0) {
        formValues.areas.forEach(area => {
            params += `&IdAreas=${area.idArea}`;
        });
    }

    try {
        const response = await api.get(`Lancamentos?${params}`);
        list = response.data;
        return list;
    } catch (err) {
        return list;
    }
}

export const LancamentosTS = () => {
    const [ListaData, setListaData] = useState(null);
    const [TotaisData, setTotaisData] = useState(null);
    const { register, handleSubmit, reset, getValues } = useForm();
    const [clientList, setClientList] = useState([]);
    var [cliente, setCliente] = useState(null);
    var [idCliente, setIdCliente] = useState(null);
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    var [peritosList, setPeritosList] = useState([]);
    var [idPeritos, setPeritosId] = useState([]);
    const [statusList, setStatusList] = useState([]);
    var [idStatus, setStatusId] = useState([]);
    var [isLoading, setisLoading] = useState(false);
    var [isSomenteProBono, setisSomenteProBono] = useState(false);
    const advanceProBono = { name: 'advanceProbono', label: 'Pro Bono' };

    const formSubmit = async (data) => {
        if(!selectedAreas || selectedAreas.length === 0) {
            Swal.fire({
                title: "Atenção",
                text: "Antes de continuar, selecione as áreas que deseja consultar.",
                icon: "error",
                confirmButtonText: "OK",
            });
            return
        }

        loadTable(data);
    }

    const loadTable = async (data) => {
        let formValues = {
            NumeroTimesheet: data?.NumeroTimesheet,
            Sigla: data?.Sigla,
            Segurado: data?.Segurado,
            idCliente: idCliente,
            idPeritos: idPeritos,
            status: idStatus,
            startDate: startDate,
            endDate: endDate,
            somenteProBono: isSomenteProBono,
            areas: selectedAreas
        };

        setisLoading(true)
        const result = await getLista(formValues);

        setListaData(result?.data?.list);
        setTotaisData(result?.data?.totais);
        setisLoading(false)
    }

    const getCliente = (currentValue, value) => {
        if (value === null || value === "") {
            cliente = null;
            idCliente = null;
            setCliente(cliente);
            setIdCliente(idCliente);
            return;
        }

        var clienteResult = clientList.filter(function (o) {
            return o.idCliente == value;
        });
        cliente = clienteResult[0].cliente;
        idCliente = clienteResult[0].idCliente;
        setCliente(cliente);
        setIdCliente(idCliente);
    };

    useEffect(() => {
        const asyncFn = async () => {
            const clients = await getClients();
            if (!!clients) {
                setClientList(clients);
            }

            const status = await getStatus(10);
            if (!!status) {
                const statusWithSelectAll = [
                    { key: 'all', value: 'Selecionar Todos' },
                    ...status
                  ];
                setStatusList(statusWithSelectAll)
            }


            const peritos = await getPeritos();
            if (!!peritos) {
                const peritosFormatados = []
                peritos.map(perito => {
                    var item = {
                        "value": perito.idUsuario,
                        "id": perito.idUsuario,
                        "label": perito.nome
                    };
                    peritosFormatados.push(item);
                });
                setPeritosList(peritosFormatados);
            }

            const allAreas = await getAreas();
            if (allAreas && allAreas.length > 0) {
                if (allAreas.length > 1) {
                    // Adiciona "Todos" somente se houver mais de uma área
                    const areasWithAll = [
                        { idArea: -1, description: "Selecionar Todos" },
                        ...allAreas
                    ];
                    setPreselectedAreas(areasWithAll);
                } else {
                    // Só uma área, então não mostra "Todos"
                    setPreselectedAreas(allAreas);
                }

                // Seleciona todas inicialmente (sem incluir o item "Todos")
                setSelectedAreas(allAreas);
            }
        }

        asyncFn();
    }, [null, 0, 10]);

    const [startDate, setStartDate] = useState(null);
    const handleStartDateChange = (date) => {
        setStartDate(date);
    }

    const [endDate, setEndtDate] = useState(null);
    const handleEndDateChange = (date) => {
        setEndtDate(date);
    }

    const exportExcel = () => {

        if (ListaData?.length === 0) {
            return;
        }

        const xlsxData = []
        ListaData?.map(meritocraciaData => {
            xlsxData.push({
                Profissional: meritocraciaData.nome,
                'Área': meritocraciaData.nomeArea,
                'Disciplina': meritocraciaData.disciplina,
                'Tipo Sinistro': meritocraciaData.tipoSinistro,
                Laudo: meritocraciaData.sigla,
                "Nº TS": meritocraciaData.numeroTimesheet,
                'Hrs PME': meritocraciaData.totalHorasExecutadasNumber,
                'Hrs Fat.': meritocraciaData.sigla && meritocraciaData.sigla.startsWith("P") ? 0 : meritocraciaData.totalHorasFaturadasNumber,
                'Hrs P.B': meritocraciaData.totalHorasProbonoNumber,
                'Hrs P.I': meritocraciaData.totalHorasProjetoInternoNumber,
                Status: meritocraciaData.statusTimesheet,
                Cliente: meritocraciaData.cliente ? meritocraciaData.cliente : '',
                Segurado: meritocraciaData.segurado ? meritocraciaData.segurado : '',
                "Atividade": meritocraciaData.descricaoAtividade ? meritocraciaData.descricaoAtividade : '',
                "Hora Início": meritocraciaData.horaInicio ? meritocraciaData.horaInicio : '00:00',
                "Hora Fim": meritocraciaData.horaFim ? meritocraciaData.horaFim : '00:00',
                'Data da Atividade': isValidDate(meritocraciaData.dataAtividade) ? formatDate(meritocraciaData.dataAtividade) : null,
                'Tipo Jornada': meritocraciaData.tipoJornada
            })
        })

        

        const worksheet = XLSX.utils.json_to_sheet(xlsxData);
        //worksheet.getColumn(14).numFmt = 'dd/mm/yyyy';

        const range = XLSX.utils.decode_range(worksheet["!ref"]);
         for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col }); // Cabeçalho está na linha 0
            if (!worksheet[cellAddress]) continue;

            worksheet[cellAddress].s = {
                font: {
                    bold: true,
                    color: { rgb: "FFFFFF" }, // Texto branco
                },
                fill: {
                    fgColor: { rgb: "EE4B21" }, // Fundo azul
                },
                border: {
                    top: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } },
                },
                alignment: {
                    horizontal: "center",
                    vertical: "center",
                },
            };
        }

        for (let row = 1; row <= range.e.r; row++) {
            for (let col = 0; col <= range.e.c; col++) {
                const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                if (!worksheet[cellAddress]) continue;

                if(col === 11 || col === 12) {
                    worksheet[cellAddress].s = {
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } },
                        },
                        alignment: {
                            horizontal: "left",
                            vertical: "center",
                        },
                    };
                } else {
                    worksheet[cellAddress].s = {
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } },
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center",
                        },
                    };
                }
            }
        }

        worksheet['!cols'] = [
            { wch: 20 },
            { wch: 15 },
            { wch: 15 },
            { wch: 27 },
            { wch: 10 },
            { wch: 7 },
            { wch: 7 },
            { wch: 7 },
            { wch: 7 },
            { wch: 7 },
            { wch: 20 },
            { wch: 50 },
            { wch: 50 },
            { wch: 50 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 20 },
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ExportDB");
        XLSX.writeFile(workbook, "Lancamentos.xlsx");
    }

    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return new Date(year, month - 1, day, 12);
        //return new Date(`${year}-${month}-${day}`);
    }

    const isValidDate = (d) => {
       const date = new Date(d);
       return d && !isNaN(date);
    };

    const autofitColumns = (json, worksheet) => {
        let objectMaxLength = [];

        json.map(jsonData => {
            Object.entries(jsonData)
                .map(([, v], idx) => {
                    let columnValue = v
                    objectMaxLength[idx] = objectMaxLength[idx] >= columnValue.length ? objectMaxLength[idx] : columnValue.length
                })
        })

        const wscols = objectMaxLength.map((w) => ({ width: w < 20 ? 20 : w }))
        worksheet["!cols"] = wscols;
    }

    const onGetPerito = (currentValue, value) => {
        let peritosList = [];
        currentValue.map(a => { peritosList.push(a.id) });
        setPeritosId(peritosList);
    };

    const onRemovePerito = (currentValue, value) => {
        onGetPerito(currentValue)
    }

    const onGetStatus = (currentValue, selectedItem) => {
        let idsList = [];
        if (selectedItem.key == 'all') {
            for (let i = 0; i < statusList.length; i++)
            {
                if (statusList[i].key != "all")
                {
                    idsList[i] = statusList[i].key;
                }
            }
            currentValue.filter(a => a.key != "all").map(a => { idsList.push(a.key) });
            setStatusId(idsList);
        }
        else
        {
            currentValue.filter(a => a.key != "all").map(a => { idsList.push(a.key) });
            setStatusId(idsList);
        }
    };

    const onRemoveStatus = (currentValue, removedItem) => {
        if (removedItem.key == 'all') {
            setStatusId([]);
        }
        else
        {
            if(idStatus.length > 1) {
                let idsRemoves = [];
                for (let i = 0; i < idStatus.length; i++)
                {
                    idsRemoves[i] = idStatus[i];
                }

                if(idsRemoves.indexOf(removedItem.key))
                {
                    const index = idsRemoves.indexOf(removedItem.key);
                    idsRemoves.splice(index, 1);
                }

                setStatusId(idsRemoves);
            }
            else {
                setStatusId([]);
            }
        }
    };


    const refreshData = async () => {
        const valuesForm = getValues();
        let formValues = {
            NumeroTimesheet: valuesForm?.NumeroTimesheet,
            Sigla: valuesForm?.Sigla,
            Segurado: valuesForm?.Segurado,
            idCliente: idCliente,
            idPeritos: idPeritos,
            status: idStatus,
            startDate: startDate,
            endDate: endDate
        };

        loadTable(formValues);
    };

    const getProbonoToggle = (status) => {
        setisSomenteProBono(status);
    };

    // Multiselect
    const [selectedAreas, setSelectedAreas] = useState([]);
    const [preselectedAreas, setPreselectedAreas] = useState([]);

    const handleSelectArea = (selectedList, selectedItem) => {
        if (selectedItem.idArea === -1) {
            // Selecionou "Todos" → seleciona todas (menos a opção "Todos")
            const onlyRealAreas = preselectedAreas.filter(a => a.idArea !== -1);
            setSelectedAreas(onlyRealAreas);
        } else {
            // Seleção normal: remove o "Todos" da lista caso esteja
            const filtered = selectedList.filter(a => a.idArea !== -1);
            setSelectedAreas(filtered);
        }
    };

    const handleRemoveArea = (selectedList, removedItem) => {
        if (removedItem.idArea === -1) {
            // Removeu "Todos" → limpa tudo
            setSelectedAreas([]);
        } else {
            const filtered = selectedList.filter(a => a.idArea !== -1);
            setSelectedAreas(filtered);
        }
    };

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">Lançamentos TS</h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                    </div>
                    <div className="card">
                        <StyledForm onSubmit={handleSubmit(formSubmit)}>
                            <div className='form-wrapper filter-container'>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Sigla'} name={'Sigla'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Nº Timesheet(Ex: TS01)'} name={'NumeroTimesheet'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicSelect
                                        placeholder={''}
                                        valuetext={cliente}
                                        label={'Selecione o cliente'}
                                        name={'idCliente'}
                                        options={clientList}
                                        keyValue={'idCliente'}
                                        keyLabel={'cliente'}
                                        paramMethod={getCliente} clearOption={true} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Segurado'} name={'Segurado'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 p-0">
                                    <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 pl-0" style={{ float: 'left' }}>
                                        <Multiselect
                                            className="searchWrapperCustom"
                                            placeholder={'Selecione a Área'}
                                            showCheckbox={true}
                                            options={preselectedAreas}
                                            selectedValues={
                                                selectedAreas.length === preselectedAreas.length - 1
                                                    ? preselectedAreas // inclui "Todos" marcado
                                                    : selectedAreas
                                            }
                                            onSelect={handleSelectArea}
                                            onRemove={handleRemoveArea}
                                            displayValue="description"
                                            showArrow={true}
                                        />
                                    </div>
                                </div>

                                {
                                    useUser()?.user.nivel != 3 && (
                                        <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                            <Multiselect
                                                className="searchWrapperCustom"
                                                placeholder={'Profissionais'}
                                                showCheckbox="true"
                                                options={peritosList} // Options to display in the dropdown
                                                onSelect={onGetPerito} // Function will trigger on select event
                                                onRemove={onRemovePerito} // Function will trigger on remove event
                                                displayValue="label" // Property name to display in the dropdown options
                                                showArrow={true}
                                            />
                                        </div>
                                    )
                                }
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2 header-select">
                                    <Multiselect
                                        className="searchWrapperCustom"
                                        placeholder={'Status TS'}
                                        showCheckbox="true"
                                        options={statusList} // Options to display in the dropdown
                                        onSelect={onGetStatus} // Function will trigger on select event
                                        onRemove={onRemoveStatus} // Function will trigger on remove event
                                        displayValue="value" // Property name to display in the dropdown options
                                        selectedValues={statusList.filter(status => idStatus.includes(status.id))}
                                        showArrow={true}
                                    />
                                </div>

                                <div className="position-relative col-sm-6 col-md-6 col-lg-6 pt-2">
                                    <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 pl-0" style={{ float: 'left' }}>
                                        <DatePicker
                                            dateFormat="dd/MM/yyyy"
                                            locale="pt-BR"
                                            className="input-form"
                                            selected={startDate}
                                            onChange={handleStartDateChange}
                                            placeholderText={'Data de início do lançamento'}
                                            customInput={<InputMask mask="99/99/9999" className="input-form py-2" style={{ width: '100%' }} />}
                                        />
                                    </div>
                                    <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 pl-0" style={{ float: 'left' }}>
                                        <DatePicker
                                            dateFormat="dd/MM/yyyy"
                                            locale="pt-BR"
                                            className="input-form"
                                            selected={endDate}
                                            onChange={handleEndDateChange}
                                            placeholderText={'Data fim do lançamento'}
                                            customInput={<InputMask mask="99/99/9999" className="input-form py-2" style={{ width: '100%' }} />}
                                        />
                                    </div>
                                </div>
                                <div className="position-relative col-sm-6 col-md-6 col-lg-6 pt-2">
                                    <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 pl-0" style={{ float: 'left' }}>
                                        <ToggleSwitch config={advanceProBono} setStatus={(status) => getProbonoToggle(status)} />
                                    </div>
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 p-2">
                                    <input type="submit" className='default-button-red' value='Pesquisar' />
                                    {
                                        ListaData?.length > 0 && (<input type="button" className='default-button-red ml-3' value='Exportar' onClick={exportExcel} />)
                                    }
                                </div>
                            </div>
                        </StyledForm>
                        <br />
                        <StldRow>
                            <Flex>
                                <StyledForm style={{ width: "100%" }}>
                                    {isLoading ?
                                        <StldRow>
                                            <div className="text-center">
                                                <div className="align-items-center">
                                                    <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                                    <div><strong style={{ color: "#EE4B21" }}>Pesquisando...</strong></div>
                                                </div>
                                            </div>
                                        </StldRow> : (
                                            <StyledTablePage>

                                                {

                                                    ListaData != null && ListaData?.length > 0 ? (
                                                        <div className="table-scroll">
                                                            <table className="table table-bordered table-width" style={{ fontSize: "14px" }}>
                                                                <thead>
                                                                    {
                                                                        TotaisData?.totalHorasExecutadas != null ? (
                                                                            <tr className="custon-tr-total-lanc">
                                                                                <td colSpan={9} className="text-center "></td>
                                                                                <td className="text-right px-1"><strong>Total de horas</strong></td>
                                                                                <td className="text-center px-1">{TotaisData?.totalHorasExecutadas} </td>
                                                                                <td className="text-center px-1">{TotaisData?.totalHorasFaturadas} </td>
                                                                                <td className="text-center px-1">{TotaisData?.totalHorasProBono} </td>
                                                                                <td className="text-center px-1">{TotaisData?.totalHorasProjetoInterno}</td>
                                                                                <td className="text-center "></td>
                                                                                <td className="text-center "></td>
                                                                            </tr>

                                                                        ) : null
                                                                    }
                                                                    <tr className="table-legend-info">
                                                                        <th key="Profissional">Profissional</th>
                                                                        <th key="Área">Área</th>
                                                                        <th key="Laudo">Laudo</th>
                                                                        <th key="Nº TS">Nº TS</th>
                                                                        <th key="Status">Status TS</th>
                                                                        <th key="Cliente">Cliente</th>
                                                                        <th key="Segurado">Segurado</th>
                                                                        <th key="DescricaoAtividade">Atividade</th>
                                                                        <th key="HoraInicio">Hora Início</th>
                                                                        <th key="HoraFim">Hora Fim</th>
                                                                        <th key="Horas">Hrs PME</th>
                                                                        <th key="Horas">Hrs Fat.</th>
                                                                        <th key="Horas">Hrs P.B</th>
                                                                        <th key="Horas">Hrs P.I</th>
                                                                        <th key="DataAtividade">Data da Atividade</th>
                                                                        <th key="Visualizar">Visualizar TS</th>
                                                                        <></>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {ListaData?.map((atividade, index) => (
                                                                        <tr key={index}>
                                                                            <td className="text-center">{atividade.nome}</td>
                                                                            <td className="text-center text-no-wrap">{atividade.nomeArea}</td>
                                                                            <td className="text-center text-no-wrap">{atividade.sigla}</td>
                                                                            <td className="text-center">{atividade.numeroTimesheet}</td>
                                                                            <td className="text-center text-no-wrap">{atividade.statusTimesheet}</td>
                                                                            <td className="text-center">{atividade.cliente}</td>
                                                                            <td className="text-center">{atividade.segurado}</td>
                                                                            <td className="text-center">{atividade.descricaoAtividade}</td>
                                                                            <td className="text-center">{atividade.horaInicio == null ? '00:00' : atividade.horaInicio}</td>
                                                                            <td className="text-center">{atividade.horaFim == null ? '00:00' : atividade.horaFim}</td>
                                                                            <td className="text-center">{atividade.totalHorasExecutadas}</td>
                                                                            <td className="text-center">{atividade.sigla && atividade.sigla.startsWith("P") ? '0,00' : atividade.totalHorasFaturadas}</td>
                                                                            <td className="text-center">{atividade.sigla && atividade.sigla.startsWith("P") ? '0,00' : atividade.totalHorasProbono}</td>
                                                                            <td className="text-center">{atividade.sigla && atividade.sigla.startsWith("P") ? atividade.totalHorasProjetoInterno : '0,00'}</td>
                                                                            <td className="text-center">{new Intl.DateTimeFormat('pt-BR').format(new Date(atividade.dataAtividade))}</td>
                                                                            <td className="text-center">
                                                                            <Link
                                                                                target="_blank"
                                                                                className="menu-link"
                                                                                to={{
                                                                                    pathname: atividade.sigla?.startsWith("P") ? "/timesheetpidetalhespage/" : "/timesheetdetalhespage/",
                                                                                    hash: atividade.idTimesheet
                                                                                }}
                                                                            >
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                                                                        <path fillRule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                                                                        <path fillRule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                                                                    </svg>
                                                                                </Link>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>


                                                            </table>
                                                        </div>
                                                    ) : (
                                                        ListaData?.length == 0 &&
                                                        <StldColumn xs="12" sm="12" md="12">
                                                            <div className="alert alert-warning" role="alert">
                                                                Atenção! Nenhum resultado encontrado!
                                                            </div>
                                                        </StldColumn>
                                                    )
                                                }
                                            </StyledTablePage>
                                        )
                                    }
                                </StyledForm>
                            </Flex>
                        </StldRow>
                    </div>
                </StyledDefaultPage>
            </main>

        </section>
    );
};

export const LancamentosTSPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <LancamentosTS />

                </>
            )}
        </>
    );
};
